<template>
  <div class="grid-stack-item-content" @click.stop.prevent="handleEditClick">
    <i class="remove-icon ti ti-trash" @click.stop.prevent="handleRemoveClick"></i>
    <div class="p-2">
      <label>{{ widget?.data?.label || widget?.label || '' }}</label>
      <small>{{ widget?.data?.description || widget?.description || '' }}</small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: Number,
    widget: Object
  },
  methods: {
    handleEditClick() {
      this.$emit('edit', { widget: this.widget, index: this.index, ref: this })
    },
    handleRemoveClick() {
      this.$emit('remove', { widget: this.widget, index: this.index, ref: this })
    }
  }
}
</script>

<style lang="scss">
.grid-stack {
  .grid-stack-item-content {
    inset: 5px !important;
    cursor: pointer;
    label {
      cursor: pointer;
    }
    .remove-icon {
      font-size: 16px;
      display: none;
      position: absolute;
      top: 0;
      right: 0;
      background: #fff;
      padding: 5px 10px;
      cursor: pointer;
      z-index: 10;
    }
    &:hover {
      .remove-icon {
        display: block;
      }
    }
  }
}
</style>
